module.exports = __webpack_public_path__ + "public/img/manjian@2x.7446da0b.png";